import { Injectable, OnDestroy } from '@angular/core';
import { AuthService } from './auth.service';
import { LocalStorageService } from './local-storage.service';
import { Subscription, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProfileService } from './profile.service';

@Injectable({
  providedIn: 'root',
})
export class TokenRefreshService implements OnDestroy {
  private readonly REFRESH_INTERVAL = 14 * 60 * 1000; // 14 minutes in milliseconds
  private refreshSubscription: Subscription | null = null;

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private profileService: ProfileService,
  ) {}

  startTokenRefresh(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }

    this.refreshSubscription = timer(this.REFRESH_INTERVAL, this.REFRESH_INTERVAL).subscribe(() => {
      const token = this.localStorageService.getToken();
      this.profileService.getProfile();

      if (token) {
        this.authService.refreshToken().toPromise().then(() => {
          console.log('Token refreshed successfully');
        }).catch((err: any) => {
          console.error('Token refresh failed', err);
        });
      }
    });
  }

  stopTokenRefresh(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
      this.refreshSubscription = null;
    }
  }

  ngOnDestroy(): void {
    this.stopTokenRefresh();
  }
}
